var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5052 16.4241C37.5452 13.1691 34.8302 10.4541 31.5752 9.49412C29.1002 8.77412 27.3902 8.83412 26.2052 9.71912C24.7802 10.7841 24.6152 12.7041 24.6152 14.0691V17.8041C24.6152 21.4941 26.2952 23.3691 29.5952 23.3691H33.9002C35.2502 23.3691 37.1852 23.2041 38.2502 21.7791C39.1652 20.6091 39.2402 18.8991 38.5052 16.4241Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3651 26.0397C33.9751 25.5897 33.4051 25.3347 32.8201 25.3347H27.4501C24.8101 25.3347 22.6651 23.1897 22.6651 20.5497V15.1797C22.6651 14.5947 22.4101 14.0247 21.9601 13.6347C21.5251 13.2447 20.9251 13.0647 20.3551 13.1397C16.8301 13.5897 13.5901 15.5247 11.4751 18.4347C9.34509 21.3597 8.56509 24.9297 9.24009 28.4997C10.2151 33.6597 14.3401 37.7847 19.5151 38.7597C20.3401 38.9247 21.1651 38.9997 21.9901 38.9997C24.7051 38.9997 27.3301 38.1597 29.5651 36.5247C32.4751 34.4097 34.4101 31.1697 34.8601 27.6447C34.9351 27.0597 34.7551 26.4747 34.3651 26.0397Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.3b52922bfd227beb53233a1589370d24.svg";
export { ForwardRef as ReactComponent };